// extracted by mini-css-extract-plugin
export var messageSideLeft = "_qu-1";
export var stateContainer = "_qu-0";